// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"369d5bd9","193":"88f28062","210":"28dfa609","274":"8723b9b4","293":"1c3ad343","357":"cee35bdd","358":"f5fb9d6a","410":"79a86e77","534":"a4e68f35","660":"88d528ac","713":"a4e68f35","789":"94ad1f83","975":"2e48e166"}[chunkId] + ".chunk.css";
};